import { FunctionComponent } from "react";
import styles from "./Switch.module.scss";
import { Switch } from "@rmwc/switch";
import "@rmwc/switch/styles";

type ownProps = {
  label: string;
  checked: boolean;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
};

const SwitchComponent: FunctionComponent<ownProps> = (props: ownProps) => {
  const { label, checked } = props;
  return (
    <div className={styles.CheckboxComponent}>
      <Switch
        checked={checked}
        onChange={(evt: React.FormEvent<HTMLInputElement>) =>
          props.onChange && props.onChange(evt)
        }
      >
        {label}
      </Switch>
    </div>
  );
};

export { SwitchComponent, SwitchComponent as default };
